/**
 * Overtime Status Badge Komponenti
 * 
 * Fazla mesai durumunu görsel olarak gösteren badge komponenti.
 * Pending, Approved, Rejected durumları için farklı renkler ve ikonlar kullanır.
 * 
 * Kullanım:
 * <OvertimeStatusBadge status={OvertimeStatus.PENDING} />
 */

import React from 'react';
import { OvertimeStatus } from '../../../../types/overtime.types';
import { OVERTIME_STATUS_CONFIG } from '../../../../constants/overtimeConstants';
import { useTranslation } from 'react-i18next';

interface OvertimeStatusBadgeProps {
  status: OvertimeStatus;
  showIcon?: boolean; // İkon gösterilsin mi? (varsayılan: true)
  className?: string; // Ek CSS class'ları
}

/**
 * Overtime durum badge komponenti
 * @param status - Overtime durumu (pending, approved, rejected)
 * @param showIcon - İkon gösterilsin mi?
 * @param className - Ek CSS class'ları
 */
const OvertimeStatusBadge: React.FC<OvertimeStatusBadgeProps> = ({ 
  status, 
  showIcon = true,
  className = '' 
}) => {
  const { i18n } = useTranslation();
  
  // Durum konfigürasyonunu al
  const config = OVERTIME_STATUS_CONFIG[status] || OVERTIME_STATUS_CONFIG[OvertimeStatus.PENDING];
  
  // Dil durumuna göre metni seç
  const text = i18n.language === 'en' ? config.textEn : config.text;

  return (
    <span 
      className={`badge ${config.color} d-inline-flex align-items-center badge-xs ${className}`}
      style={{ fontSize: '0.875rem', padding: '0.25rem 0.75rem' }}
    >
      {showIcon && (
        <i className={`${config.iconClass} me-1`} style={{ fontSize: '1rem' }} />
      )}
      {text}
    </span>
  );
};

export default OvertimeStatusBadge;


